import { useMemo, useCallback } from 'react';
import { analyticsClient, EventType, Properties } from 'src/shared/services/analytics';
import { HpiEligibilityFlow } from 'src/shared/models/shared';

export const useHpiEligibilityFlowAnalytics = (pageName: string, flowName: HpiEligibilityFlow) => {
    const hpiEligibilityFlow = useMemo(() => {
        return flowName ?? HpiEligibilityFlow.Therapy;
    }, [flowName]);

    const eventTag = hpiEligibilityFlow === HpiEligibilityFlow.Psychiatry ? '(PAMM)' : '(Therapy)';

    const track = useCallback(
        (actionName: string, properties?: Properties) => {
            analyticsClient.track(`${eventTag} ${actionName}`, EventType.API, {
                page_name: pageName,
                hpi_eligibility_flow: hpiEligibilityFlow,
                ...properties,
            });
        },
        [pageName, hpiEligibilityFlow, eventTag],
    );

    const trackClick = useCallback(
        (actionName: string, properties?: Properties) => {
            analyticsClient.trackClick(`${eventTag} ${actionName}`, {
                page_name: pageName,
                hpi_eligibility_flow: hpiEligibilityFlow,
                ...properties,
            });
        },
        [pageName, hpiEligibilityFlow, eventTag],
    );

    return { track, trackClick };
};
